import { useTranslation } from "react-i18next";

import { Alert, InputAdornment, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormikDecimalTextField } from "../../../../../../formik/FormikDecimalTextField";
import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { IncomeSectionCard } from "../../../income/components/income-section-card/IncomeSectionCard";
import { FieldWithInfo } from "../../../personal-data/components/field-with-info/FieldWithInfo";
import { AssetExpensesFormValues } from "../../ExpensesView.types";

const SECTION = "clients.client.debtSettlement.assetInventory.expensesTab.generalQuestions";

interface Props {
  formik: FormikProps<AssetExpensesFormValues>;
}

export function GeneralQuestionsSection({ formik }: Props) {
  const { t } = useTranslation();
  const hasIllnessExtraCosts = formik.values.hasIllnessExtraCosts === true;
  const questionLabel = t(`${SECTION}.hasIllnessExtraCosts`);

  return (
    <IncomeSectionCard title={t(`${SECTION}.title`)}>
      <Stack gap={1}>
        <FieldWithInfo fieldLabel={questionLabel} info={t(`${SECTION}.hasIllnessExtraCostsInfo`)}>
          <FormikYesNoAutocomplete
            id="expenses-has-illness-extra-costs"
            formik={formik}
            fieldName="hasIllnessExtraCosts"
            label={questionLabel}
          />
        </FieldWithInfo>
        {hasIllnessExtraCosts && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {t(`${SECTION}.proofRequired`)}
            </Alert>
            <FormikDecimalTextField
              id="expenses-illness-extra-cost-amount"
              formik={formik}
              fieldName="illnessExtraCostAmount"
              label={t(`${SECTION}.illnessExtraCostAmount`)}
              decimalScale={2}
              minValue={0}
              slotProps={{ input: { endAdornment: <InputAdornment position="end">€</InputAdornment> } }}
            />
          </>
        )}
      </Stack>
    </IncomeSectionCard>
  );
}
